import { Inject, Injectable } from '@angular/core';
import { Route, Router, UrlSegment, UrlTree } from '@angular/router';
import { FeatureFlagService } from '@galaxy/partner';
import { Observable, combineLatest } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class AccessFeatureFlagGuard {
  constructor(
    private readonly router: Router,
    private readonly featureService: FeatureFlagService,
    @Inject('PARTNER_ID') private readonly partnerId$: Observable<string>,
    @Inject('MARKET_ID') private readonly marketId$: Observable<string>,
  ) {}

  canMatch(route: Route, _segments: UrlSegment[]): Observable<boolean | UrlTree> {
    const featureFlag = route.data.featureFlag;
    return combineLatest([this.partnerId$, this.marketId$]).pipe(
      switchMap(([partnerId, marketId]) => this.featureService.batchGetStatus(partnerId, marketId, [featureFlag])),
      map((flags) => {
        return !!flags[featureFlag];
      }),
    );
  }
}
